/**
 * section__compare-models.js
 * FINAL VERSION — stable ordering + URL sync (no auto-prune) + colorless-fallback
 */
(function () {
  // --- Global Element References ---
  const emptySidebars = Array.from(document.querySelectorAll('.empty-sidebar-div'));
  const topPane = document.querySelector('.top-items-scroll');
  const headerContainer = document.querySelector('.compare-results__items-fixed');
  const bodyContainer = document.querySelector('.compare-results__items:not(.compare-results__items-fixed)');

  // --- Helper Functions ---
  function setMaxHeight(containers) {
    let maxH = 0;
    containers.forEach(c => {
      c.style.minHeight = '';
      const h = c.offsetHeight;
      if (h > maxH) maxH = h;
    });
    containers.forEach(c => c.style.minHeight = maxH + 'px');
  }

  function initContainerHeight() {
    hideEmptyAccessoryCompatibilityRow();
    const class_str = 'how-it-feels, who-its-for, price, battery-range, tires, weight, payload-capacity, folded-dimensions, frame-options, rider-height, top-speed, accessory-compatibility, stand-out-features, motor-power, unfolded-dimensions, brakes, drivetrain, freewheel, suspension, throttle, handlebar-stem, pedal-assist-sensor';
    class_str.split(',').forEach((className) => {
      const els = document.querySelectorAll('.' + className.trim());
      if (els.length) setMaxHeight(Array.from(els));
    });
  }

  function hideEmptyAccessoryCompatibilityRow() {
    const itemRows = document.querySelectorAll('.accessory-compatibility.item-row');
    const allEmpty = Array.from(itemRows).every(el => el.textContent.trim() === '');
    const allAccessibilityEls = document.querySelectorAll('.accessory-compatibility');
    allAccessibilityEls.forEach(el => el.style.display = allEmpty ? 'none' : '');
  }

  function updateDropdownStates(orderedHandles) {
    const selected = new Set(orderedHandles || []);
    document.querySelectorAll('.header-dropdown .product-select').forEach(select => {
      const currentColumnHandle = select.closest('.results-col').dataset.item;
      select.value = currentColumnHandle;
      select.querySelectorAll('option').forEach(option => {
        const optionHandle = option.value;
        option.disabled = (selected.has(optionHandle) && optionHandle !== currentColumnHandle);
      });
    });
  }

  /*
  // --- Drawer helpers (only for explicit remove/clear) ---
  const COMPARE_STORAGE_KEY = 'lectric_compare_v1';
  function _hardLoadDrawer() {
    try {
      const raw = localStorage.getItem(COMPARE_STORAGE_KEY);
      return raw ? JSON.parse(raw) : { items: [], ts: Date.now() };
    } catch (_) {
      return { items: [], ts: Date.now() };
    }
  }
  function _hardSaveDrawer(data) {
    try {
      localStorage.setItem(COMPARE_STORAGE_KEY, JSON.stringify(data));
      window.dispatchEvent(new CustomEvent('compare:changed', { detail: data.items || [] }));
    } catch (_) {}
  }
  function _removeFromDrawerByModel(modelKey) {
    const key = (modelKey || '').toLowerCase().trim();
    const data = _hardLoadDrawer();
    data.items = (data.items || []).filter(it => (it.modelKey || '').toLowerCase().trim() !== key);
    data.ts = Date.now();
    _hardSaveDrawer(data);
  }
  */

  // const COMPARE_STORAGE_KEY = 'lectric_compare_v1';
  const COMPARE_STORAGE_KEY = 'lectric_compare_v2';
  const COMPARE_STORAGE_KEY_LEGACY = 'lectric_compare_v1';

  function _hardLoadDrawer() {
    try {
        const rawV2 = localStorage.getItem(COMPARE_STORAGE_KEY);
        if (rawV2) return JSON.parse(rawV2);
        // one-time read from v1 if v2 missing
        const rawV1 = localStorage.getItem(COMPARE_STORAGE_KEY_LEGACY);
        if (rawV1) {
        const data = JSON.parse(rawV1);
        localStorage.setItem(COMPARE_STORAGE_KEY, JSON.stringify({ items: data.items || [], ts: Date.now() }));
        return { items: data.items || [], ts: Date.now() };
        }
        return { items: [], ts: Date.now() };
    } catch (_) {
        return { items: [], ts: Date.now() };
    }
  }  

  function _hardSaveDrawer(data) {
    try {
        localStorage.setItem(COMPARE_STORAGE_KEY, JSON.stringify(data));
        window.dispatchEvent(new CustomEvent('compare:changed', { detail: data.items || [] }));
    } catch (_) {}
  }

  // ---- canonical model key shim (delegates to compare.js; safe fallback) ----
  const _safeCanonicalModelKey = (function () {
    // Local fallback ONLY if compare.js isn't ready yet.
    function localCanonicalModelKey(raw) {
      const s = (raw || '').toLowerCase().trim();
      if (!s) return '';

      // specific non-XP first
      if (/\bxpress(?:-?1)?\b|\bxpress\b/.test(s)) return 'xpress';
      if (/\bone\b/.test(s)) return 'one';

      // XP LITE 2 (must include bare token)
      if (/\bxplite2\b/.test(s) || /\bxp[\s-]*lite\b/.test(s) || /\bxpl[\s-]*2\b/.test(s) || /\blite-?2\b/.test(s) || /\blite\s*2(\.0)?\b/.test(s)) {
        return 'xplite2';
      }

      // XP sub-families
      if (/\bxp[\s-]*edition(?:-?2)?\b|\bxpedition(?:-?2)?\b|\bxped-?2\b/.test(s)) return 'xpedition2';
      if (/\bxp[\s-]*peak(?:-?2)?\b|\bxpeak(?:-?2)?\b/.test(s)) return 'xpeak2';
      if (/\btrike(?:-?2)?\b/.test(s)) return 'trike2';

      // XP 4
      if (/\bxp[\s-]*4(\.0)?\b|\bbike-?4\b/.test(s)) return 'xp4';

      // generic xp (do LAST)
      if (/\bxp\b/.test(s)) return 'xp4';

      return '';
    }

    return function (val) {
      try {
        const fn = window.LectricCompare && window.LectricCompare.canonicalModelKey;
        if (typeof fn === 'function') return fn(val);   // delegate to compare.js (single source of truth)
      } catch (_) {}
      return localCanonicalModelKey(val);               // safe fallback
    };
  })();


  function __getUrlModels() {
    const u = new URL(location.href);
    const joined = (u.searchParams.getAll('models') || []).filter(Boolean).join(',') ||
                  (u.searchParams.get('models') || '');
    return joined.split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
  }


  // --- URL helpers ---
  function _getUrlHandles() {
    const url = new URL(location.href);
    return (url.searchParams.get('compare') || '')
      .split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
  }
  function _setUrlHandles(handles, extra = {}) {
    const url = new URL(location.href);
    url.searchParams.set('compare', (handles || []).join(','));
    if (Array.isArray(extra.models)) url.searchParams.set('models', extra.models.join(','));
    if (Array.isArray(extra.colors)) url.searchParams.set('colors', extra.colors.join(','));
    history.replaceState(null, '', url.toString());
  }

  // --- Handle helpers for color matching ---
  function _stripSuffixes(key) {
    return (key || '')
      .toLowerCase()
      .replace(/-long-?range-?ebike?$/, '')
      .replace(/-long-?range$/, '')
      .replace(/-ebike$/, '');
  }

  const _COLOR_WORDS = new Set([
    'black','white','blue','navy','raindrop','cobalt','red','crimson','phoenix',
    'green','pine','olive','grey','gray','silver','charcoal','graphite',
    'sand','sandstorm','beige','brown','gold','bronze','orange','yellow',
    'purple','lavender','haze','pink','teal','cyan','thistle','lilac','forest','matte'
  ]);

  function _extractColorToken(rawHandle) {
    const h = (rawHandle || '').toLowerCase();
    const parts = _stripSuffixes(h).split('-').filter(Boolean);
    for (let i = parts.length - 1; i >= 0; i--) {
      const p = parts[i];
      if (_COLOR_WORDS.has(p)) return p;
    }
    return '';
  }

  function _hasColorTokenInUrl(u) {
    const slug = (u || '').toLowerCase();
    for (const w of _COLOR_WORDS) {
      if (slug.includes(`-${w}`)) return true;
    }
    return false;
  }

  // --- Bubbles / CTA helpers ---
  function ensureDefaultBubble(card) {
    if (!card) return;

    const alreadyActive = card.querySelector('.color-variant-wrapper .bubble.active');
    if (alreadyActive) {
      const btn = card.querySelector('.bottom-col a.button, .bottom-col a.button--primary');
      if (btn && !btn.dataset.defaultUrl) btn.dataset.defaultUrl = btn.getAttribute('href') || '';
      const variantUrl = alreadyActive.dataset.variantUrl || alreadyActive.dataset.variantUrlDefault || (btn && btn.dataset.defaultUrl) || '';
      if (btn && variantUrl) btn.setAttribute('href', variantUrl);
      return;
    }

    const fallback = card.querySelector('.color-variant-wrapper .bubble.selected')
                  || card.querySelector('.color-variant-wrapper .bubble');
    if (!fallback) return;

    fallback.classList.add('active');

    const img = card.querySelector('.bike-image img');
    const imgUrl = fallback.dataset.imageUrl;
    if (img && imgUrl) img.src = imgUrl;

    const btn = card.querySelector('.bottom-col a.button, .bottom-col a.button--primary');
    if (btn) {
      if (!btn.dataset.defaultUrl) btn.dataset.defaultUrl = btn.getAttribute('href') || '';
      const variantUrl = fallback.dataset.variantUrl || fallback.dataset.variantUrlDefault || btn.dataset.defaultUrl;
      if (variantUrl) btn.setAttribute('href', variantUrl);
    }
  }

  function ensurePreferredBubble(card, preferredRaw) {
    if (!card) return;

    const active = card.querySelector('.color-variant-wrapper .bubble.active');
    if (active && preferredRaw) {
      const vurl = (active.dataset.variantUrl || '').toLowerCase();
      if (vurl.includes(preferredRaw)) return;
    }

    const bubbles = Array.from(card.querySelectorAll('.color-variant-wrapper .bubble'));
    const img = card.querySelector('.bike-image img');
    const btn = card.querySelector('.bottom-col a.button, .bottom-col a.button--primary');

    // Exact handle match
    if (preferredRaw) {
      const exact = bubbles.find(b => {
        const vurl = (b.dataset.variantUrl || b.getAttribute('href') || '').toLowerCase();
        return vurl.includes(preferredRaw);
      });
      if (exact) {
        if (img && exact.dataset.imageUrl) img.src = exact.dataset.imageUrl;
        card.querySelectorAll('.color-variant-wrapper .bubble.active').forEach(b => b.classList.remove('active'));
        exact.classList.add('active');
        if (btn) {
          if (!btn.dataset.defaultUrl) btn.dataset.defaultUrl = btn.getAttribute('href') || '';
          const variantUrl = exact.dataset.variantUrl || exact.dataset.variantUrlDefault || btn.dataset.defaultUrl;
          if (variantUrl) btn.setAttribute('href', variantUrl);
        }
        return;
      }
    }

    // Color-token match
    const colorToken = _extractColorToken(preferredRaw);
    if (colorToken) {
      const colorMatch = bubbles.find(b => {
        const vurl = (b.dataset.variantUrl || b.getAttribute('href') || '').toLowerCase();
        const colorAttr =
          (b.dataset.color || b.getAttribute?.('data-value') || b.getAttribute?.('aria-label') || '').toLowerCase();
        return vurl.includes(colorToken) || colorAttr.includes(colorToken);
      });
      if (colorMatch) {
        if (img && colorMatch.dataset.imageUrl) img.src = colorMatch.dataset.imageUrl;
        card.querySelectorAll('.color-variant-wrapper .bubble.active').forEach(b => b.classList.remove('active'));
        colorMatch.classList.add('active');
        if (btn) {
          if (!btn.dataset.defaultUrl) btn.dataset.defaultUrl = btn.getAttribute('href') || '';
          const variantUrl = colorMatch.dataset.variantUrl || colorMatch.dataset.variantUrlDefault || btn.dataset.defaultUrl;
          if (variantUrl) btn.setAttribute('href', variantUrl);
        }
        return;
      }
    }

    // NEW: If preferred has **no** color token, pick the bubble whose URL also has **no** color token (e.g., "white/default")
    if (!preferredRaw && !colorToken) {
      const noColor = bubbles.find(b => !_hasColorTokenInUrl(b.dataset.variantUrl || b.getAttribute('href') || ''));
      if (noColor) {
        if (img && noColor.dataset.imageUrl) img.src = noColor.dataset.imageUrl;
        card.querySelectorAll('.color-variant-wrapper .bubble.active').forEach(b => b.classList.remove('active'));
        noColor.classList.add('active');
        if (btn) {
          if (!btn.dataset.defaultUrl) btn.dataset.defaultUrl = btn.getAttribute('href') || '';
          const variantUrl = noColor.dataset.variantUrl || noColor.dataset.variantUrlDefault || btn.dataset.defaultUrl;
          if (variantUrl) btn.setAttribute('href', variantUrl);
        }
        return;
      }
    }

    // Default
    ensureDefaultBubble(card);
  }

  // --- Main Logic Block ---
  let selections = []; // [{ raw, resolved }]

  const allToggle = document.getElementById('all');
  const modelCheckboxes = Array.from(document.querySelectorAll('input[name="select-model"]:not(#all)'));
  const allCards = Array.from(document.querySelectorAll('.results-col'));

  const compareResultsContainer = document.querySelector('.compare-results');
  const emptyStateContainer = document.querySelector('.compare-empty-state-container');

  // ---- dynamic variant → canonical resolver --------------------------------
  function extractHandleFromUrl(u) {
    if (!u) return '';
    try {
      const url = new URL(u, window.location.origin);
      const parts = url.pathname.split('/').filter(Boolean);
      const idx = parts.indexOf('products');
      if (idx > -1 && parts[idx + 1]) return parts[idx + 1].toLowerCase();
      return (parts[parts.length - 1] || '').toLowerCase();
    } catch {
      const path = (u || '').split('?')[0].split('#')[0];
      const parts = path.split('/').filter(Boolean);
      return (parts[parts.length - 1] || '').toLowerCase();
    }
  }

  function buildDynamicResolver() {
    const map = new Map();

    allCards.forEach(card => {
      const canonical = (card.dataset.item || '').toLowerCase();
      if (!canonical) return;

      // canonical maps to itself
      map.set(canonical, canonical);

      // bubbles map variant handles → canonical
      card.querySelectorAll('.color-variant-wrapper .bubble').forEach(b => {
        const v1 = b.dataset.variantUrl || b.getAttribute('href') || '';
        const a1 = extractHandleFromUrl(v1);
        if (a1) map.set(a1, canonical);

        const v2 = b.dataset.variantUrlDefault || '';
        const a2 = extractHandleFromUrl(v2);
        if (a2) map.set(a2, canonical);
      });
    });

    // And: map family-prefix → first matching canonical (xp-lite → xp-lite-…)
    const seenPrefix = new Set();
    allCards.forEach(card => {
      const canonical = (card.dataset.item || '').toLowerCase();
      const parts = canonical.split('-');
      if (parts[0] === 'xp' && parts.length >= 2) {
        const prefix = `${parts[0]}-${parts[1]}`; // e.g., xp-lite
        if (!seenPrefix.has(prefix)) {
          map.set(prefix, canonical);
          seenPrefix.add(prefix);
        }
      } else {
        const base = parts[0];
        if (base && !seenPrefix.has(base)) {
          map.set(base, canonical);
          seenPrefix.add(base);
        }
      }
    });

    // bottom CTA hrefs (if they point to /products/<handle>)
    allCards.forEach(card => {
      const canonical = (card.dataset.item || '').toLowerCase();
      const btn = card.querySelector('.bottom-col a.button, .bottom-col a.button--primary');
      if (!btn) return;
      const alias = extractHandleFromUrl(btn.getAttribute('href') || '');
      if (alias) map.set(alias, canonical);
    });

    return map;
  }

  const _resolverMap = buildDynamicResolver();

  // Pull best-available details from a visible compare column and upsert to drawer.
  function hydrateDrawerFromColumn(resolvedHandle) {
    try {
      const col =
        document.querySelector(`.compare-results__items-fixed .results-col[data-item="${resolvedHandle}"]`) ||
        document.querySelector(`.compare-results__items:not(.compare-results__items-fixed) .results-col[data-item="${resolvedHandle}"]`);
      if (!col) return;

      // title
      const title =
        (col.querySelector('.title, .product-title, .header-title, [data-title]')?.textContent || '').trim() ||
        resolvedHandle;

      // active bubble (for color + variant url + image)
      const bubble =
        col.querySelector('.color-variant-wrapper .bubble.active') ||
        col.querySelector('.color-variant-wrapper .bubble.selected') ||
        col.querySelector('.color-variant-wrapper .bubble');

      const color =
        (bubble?.dataset?.color ||
        bubble?.getAttribute?.('data-value') ||
        bubble?.getAttribute?.('aria-label') ||
        '').trim();

      const vurl = (bubble?.dataset?.variantUrl || bubble?.getAttribute?.('href') || '').trim();

      // CTA href as a secondary source for vurl
      const cta = col.querySelector('.bottom-col a.button, .bottom-col a.button--primary');
      const ctaHref = (cta?.getAttribute?.('href') || '').trim();

      // image
      const img = col.querySelector('.bike-image img') || col.querySelector('img');
      const image = (img?.getAttribute?.('src') || '').trim();

      // product handle (from vurl/cta)
      function extractHandle(u) {
        if (!u) return '';
        try {
          const url = new URL(u, location.origin);
          const parts = url.pathname.split('/').filter(Boolean);
          const idx = parts.indexOf('products');
          return (idx > -1 && parts[idx + 1]) ? parts[idx + 1].toLowerCase() : (parts[parts.length - 1] || '').toLowerCase();
        } catch {
          const path = (u || '').split('?')[0].split('#')[0];
          const parts = path.split('/').filter(Boolean);
          return (parts[parts.length - 1] || '').toLowerCase();
        }
      }
      const handle = extractHandle(vurl) || extractHandle(ctaHref) || resolvedHandle;

      const item = {
        modelKey: _safeCanonicalModelKey(resolvedHandle),
        handle,
        title,
        image,
        color,
        vurl: vurl || ctaHref
      };

      // Upsert into drawer storage (preserves order/other items)
      if (window.LectricCompare && typeof window.LectricCompare.add === 'function') {
        window.LectricCompare.add(item);
      }
    } catch (_) {}
  }


  function _firstCanonicalByPrefix(prefix) {
    prefix = (prefix || '').toLowerCase();
    if (!prefix) return '';
    const card = Array.from(document.querySelectorAll('.results-col'))
      .find(c => (c.dataset.item || '').toLowerCase().startsWith(prefix));
    return (card && (card.dataset.item || '').toLowerCase()) || '';
  }

  function resolveHandle(h) {
    const key = (h || '').toLowerCase();
    const stripped = _stripSuffixes(key);

    // 0) direct or stripped alias
    for (const cand of [key, stripped]) {
      if (cand && _resolverMap.has(cand)) return _resolverMap.get(cand);
    }

    // 1) XP sub-families
    const tokens = stripped.split('-').filter(Boolean);
    if (tokens[0] === 'xp' && tokens.length >= 2) {
      const xpPrefix = `${tokens[0]}-${tokens[1]}`;
      const hit = _firstCanonicalByPrefix(xpPrefix);
      if (hit) return hit;
    }

    // 2) Non-XP families
    if (tokens.length) {
      const base = tokens[0];
      const hit = _firstCanonicalByPrefix(base);
      if (hit) return hit;
    }

    // 3) Last resort: contains
    const t0 = tokens[0] || '';
    const any = Array.from(document.querySelectorAll('.results-col'))
      .map(c => (c.dataset.item || '').toLowerCase())
      .find(hh => t0 && hh.includes(t0));
    return any || stripped || key;
  }

  // Returns best "raw" (variant) handle for a given column already in the DOM
  function _activeRawForHandle(resolvedHandle) {
    const col = headerContainer.querySelector(`.results-col[data-item="${resolvedHandle}"]`)
            || bodyContainer.querySelector(`.results-col[data-item="${resolvedHandle}"]`);
    if (!col) return '';

    const bubble =
      col.querySelector('.color-variant-wrapper .bubble.active') ||
      col.querySelector('.color-variant-wrapper .bubble.selected') ||
      col.querySelector('.color-variant-wrapper .bubble');

    if (!bubble) return '';

    const vurl = bubble.dataset.variantUrl || bubble.getAttribute('href') || '';
    if (!vurl) return '';

    try {
      const url = new URL(vurl, window.location.origin);
      const parts = url.pathname.split('/').filter(Boolean);
      const idx = parts.indexOf('products');
      const slug = idx > -1 && parts[idx + 1] ? parts[idx + 1] : (parts[parts.length - 1] || '');
      return (slug || '').toLowerCase();
    } catch {
      const path = (vurl || '').split('?')[0].split('#')[0];
      const parts = path.split('/').filter(Boolean);
      return (parts[parts.length - 1] || '').toLowerCase();
    }
  }

  // Build from current checkboxes (used only when no URL and as a fallback)
  function rebuildSelectionsFromCheckboxes() {
    const prevByResolved = new Map((selections || []).map(s => [s.resolved, s.raw]));

    const rows = modelCheckboxes
      .filter(cb => cb.checked)
      .map(cb => {
        const rawFromCb = (cb.value || '').toLowerCase();
        const resolved = resolveHandle(rawFromCb);

        let raw = prevByResolved.get(resolved);
        if (!raw) {
          const guess = _activeRawForHandle(resolved);
          if (guess) raw = guess;
        }
        if (!raw) raw = resolved;

        return { raw, resolved };
      });

    selections = rows;
  }

  function _updateUrlFromSelections() {
    const handles = (selections || [])
      .map(s => (s.raw || s.resolved || '').toLowerCase())
      .filter(Boolean);

    const models  = (selections || [])
      .map(s => _safeCanonicalModelKey(s.resolved) || _safeCanonicalModelKey(s.raw) || '');

    const colors  = (selections || [])
      .map(s => _extractColorToken(s.raw || s.resolved) || '');

    _setUrlHandles(handles, { models, colors });
  }

  function getPreferredRawForResolved(resolvedHandle) {
    const entry = selections.find(s => s.resolved === resolvedHandle);
    return entry ? entry.raw : null;
  }

  // ---- render ---------------------------------------------------------------
  function renderOrderedView() {
    const orderedHandles = selections.map(s => s.resolved);
    const hasItems = orderedHandles.length > 0;

    if (hasItems) {
      compareResultsContainer.style.display = 'block';
      if (emptyStateContainer) emptyStateContainer.style.display = 'none';
    } else {
      compareResultsContainer.style.display = 'none';
      if (emptyStateContainer) emptyStateContainer.style.display = 'block';
    }

    if (hasItems) {
      Array.from(document.querySelectorAll('.results-col')).forEach(card => (card.style.display = 'none'));

      orderedHandles.forEach(handle => {
        const headerCol = headerContainer.querySelector(`.results-col[data-item="${handle}"]`);
        const bodyCol   = bodyContainer.querySelector(`.results-col[data-item="${handle}"]`);
        const preferredRaw = getPreferredRawForResolved(handle);

        if (headerCol) {
          headerCol.style.display = 'block';
          headerContainer.appendChild(headerCol);
          ensurePreferredBubble(headerCol, preferredRaw);
        }
        if (bodyCol) {
          bodyCol.style.display = 'block';
          bodyContainer.appendChild(bodyCol);
          ensurePreferredBubble(bodyCol, preferredRaw);
        }
      });

      updateDropdownStates(orderedHandles);
      setTimeout(() => {
        initContainerHeight();
        if (topPane) {
          const liveTopH = topPane.getBoundingClientRect().height;
          emptySidebars.forEach(div => (div.style.height = liveTopH + 'px'));
        }
      }, 50);
    }

    const allToggleEl = document.getElementById('all');
    if (allToggleEl) {
      const allCbs = modelCheckboxes.length;
      const allCheckedCount = modelCheckboxes.filter(cb => cb.checked).length;
      allToggleEl.checked = (allCbs > 0 && hasItems && allCheckedCount === allCbs);
    }
  }

  // ---- init / listeners -----------------------------------------------------
  (function initializeListeners() {
    const params = new URLSearchParams(window.location.search);
    const rawCompare = params.get('compare');
    const urlHandles = (rawCompare || '')
      .split(',')
      .map(decodeURIComponent)
      .map(s => s.trim().toLowerCase())
      .filter(Boolean);

    if (urlHandles.length) {
      // Build selections from URL (preserve URL order)
      selections = urlHandles.map(h => {
        const raw = (h || '').toLowerCase();
        return { raw, resolved: resolveHandle(raw) };
      });

      // Check the matching checkboxes
      modelCheckboxes.forEach(cb => (cb.checked = false));
      urlHandles.forEach(h => {
        const resolved = resolveHandle(h);
        let cb = document.querySelector(`input[name="select-model"][value="${resolved}"]`);
        if (!cb) {
          const base = h.split('-').slice(0, 2).join('-');
          cb = Array.from(document.querySelectorAll('input[name="select-model"]'))
            .find(el => el.value.toLowerCase().startsWith(base));
        }
        if (cb) cb.checked = true;
      });

      // ✅ NEW: also mirror URL models into the drawer storage (order preserved)
      /*window.LectricCompare?.forceFromModels(__getUrlModels());*/
      {
        const models = __getUrlModels();
        if (models.length) {
          window.LectricCompare?.forceFromModels(models);
        }
        // If there are no models in the URL, do nothing (don’t clear storage).
      }

    } else {
      // No URL: build from checkboxes
      rebuildSelectionsFromCheckboxes();
    }

    renderOrderedView();

    if (urlHandles.length) {
      selections.forEach(s => hydrateDrawerFromColumn(s.resolved));
    }

    // --- hard reconcile: ensure storage count == URL models count (handles late clobbers)
    setTimeout(() => {
      const want = __getUrlModels();                                // ['xp4','trike2','xpedition2','xplite2']
      const have = (JSON.parse(localStorage.getItem('lectric_compare_v2')) || {})
                    ?.items?.map(i => (i.modelKey || '').toLowerCase().trim()) || [];
      if (want.length && want.length !== have.length) {
        window.LectricCompare?.forceFromModels(want);
      }
    }, 60);


    // Checkbox changes — maintain stable order
    modelCheckboxes.forEach(cb => {
      cb.addEventListener('change', function () {
        const valueRaw = (this.value || '').toLowerCase();
        const resolved = resolveHandle(valueRaw);

        if (!this.checked) {
          // remove: stable left-shift
          const idx = selections.findIndex(s => s.resolved === resolved);
          if (idx > -1) selections.splice(idx, 1);
          //_removeFromDrawerByModel(_safeCanonicalModelKey(resolved));
          window.LectricCompare && window.LectricCompare.removeModel(resolved);
          renderOrderedView();
          _updateUrlFromSelections();
          // Mirror URL -> drawer (v2)
          /*window.LectricCompare?.forceFromModels(__getUrlModels());*/
          {
            const models = __getUrlModels();
            if (models.length) {
              window.LectricCompare?.forceFromModels(models);
            }
            // If there are no models in the URL, do nothing (don’t clear storage).
          }
          return;
        }

        // add: push to end if not already present
        if (!selections.some(s => s.resolved === resolved)) {
          const rawGuess = _activeRawForHandle(resolved) || resolved;
          selections.push({ raw: rawGuess, resolved });
        }
        renderOrderedView();
        _updateUrlFromSelections();
        /*window.LectricCompare?.forceFromModels(__getUrlModels());*/
        {
          const models = __getUrlModels();
          if (models.length) {
            window.LectricCompare?.forceFromModels(models);
          }
          // If there are no models in the URL, do nothing (don’t clear storage).
        }
      });
    });

    // "All" toggle
    if (allToggle) {
      allToggle.addEventListener('change', () => {
        if (allToggle.checked) {
          // Select all (append any missing, in DOM order)
          modelCheckboxes.forEach(cb => {
            if (!cb.checked) {
              cb.checked = true;
              const resolved = resolveHandle(cb.value || '');
              if (!selections.some(s => s.resolved === resolved)) {
                selections.push({ raw: _activeRawForHandle(resolved) || resolved, resolved });
              }
            }
          });
        } else {
          // Clear all + clear drawer
          modelCheckboxes.forEach(cb => (cb.checked = false));
          selections = [];
          /*
          const data = _hardLoadDrawer();
          data.items = [];
          data.ts = Date.now();
          _hardSaveDrawer(data);
          */
          window.LectricCompare && window.LectricCompare.clearAll();
        }
        renderOrderedView();
        _updateUrlFromSelections();
        /*window.LectricCompare?.forceFromModels(__getUrlModels());*/
        {
          const models = __getUrlModels();
          if (models.length) {
            window.LectricCompare?.forceFromModels(models);
          }
          // If there are no models in the URL, do nothing (don’t clear storage).
        }
      });
    }

    // header dropdown swap (replace in place; order preserved)
    document.querySelectorAll('.header-dropdown .product-select').forEach(select => {
      let previousValue;
      select.addEventListener('focus', function () {
        previousValue = resolveHandle(this.value);
      });
      select.addEventListener('change', function () {
        const newRaw = (this.value || '').toLowerCase();
        const newResolved = resolveHandle(newRaw);
        const oldResolved = previousValue;

        const idx = selections.findIndex(s => s.resolved === oldResolved);
        if (idx > -1) {
          selections.splice(idx, 1, { raw: newRaw, resolved: newResolved });
        }

        const oldCheckbox =
          document.querySelector(`input[name="select-model"][value="${oldResolved}"]`) ||
          document.querySelector(`input[name="select-model"][value="${previousValue}"]`);

        const newCheckbox =
          document.querySelector(`input[name="select-model"][value="${newResolved}"]`) ||
          document.querySelector(`input[name="select-model"][value="${newRaw}"]`);

        if (oldCheckbox) oldCheckbox.checked = false;
        if (newCheckbox) newCheckbox.checked = true;

        renderOrderedView();
        _updateUrlFromSelections();
        /*window.LectricCompare?.forceFromModels(__getUrlModels());*/
        {
          const models = __getUrlModels();
          if (models.length) {
            window.LectricCompare?.forceFromModels(models);
          }
          // If there are no models in the URL, do nothing (don’t clear storage).
        }
        hydrateDrawerFromColumn(newResolved);
      });
    });

    // remove-column buttons (stable left-shift + URL sync + explicit drawer remove)
    document.querySelectorAll('.remove-column-btn').forEach(button => {
      button.addEventListener('click', function () {
        const col = this.closest('.results-col');
        const resolved = resolveHandle(col?.dataset.item || this.dataset.button || '');
        if (!resolved) return;

        //_removeFromDrawerByModel(_safeCanonicalModelKey(resolved));
        window.LectricCompare && window.LectricCompare.removeModel(resolved);

        const idx = selections.findIndex(s => s.resolved === resolved);
        if (idx > -1) selections.splice(idx, 1);

        const cb = document.querySelector(`input[name="select-model"][value="${resolved}"]`)
                || (col ? col.querySelector('input[name="select-model"]') : null);
        if (cb) cb.checked = false;

        _updateUrlFromSelections();
        renderOrderedView();
        /*window.LectricCompare?.forceFromModels(__getUrlModels());*/
        {
          const models = __getUrlModels();
          if (models.length) {
            window.LectricCompare?.forceFromModels(models);
          }
          // If there are no models in the URL, do nothing (don’t clear storage).
        }
      });
    });

    // back/forward inside compare page: reorder from URL (no storage pruning)
    function onHistoryChange() {
      const urlOrder = _getUrlHandles(); // raw handles from URL
      const models   = __getUrlModels();

      // If the new URL has no compare/models, DON'T touch storage or selections.
      if (!urlOrder.length && !models.length) {
        return; // leave drawer as-is for the collection page
      }

      if (!urlOrder.length) {
        // If models exist but compare is missing, just mirror models
        window.LectricCompare?.forceFromModels(models);
        return;
      }

      // (existing reorder logic …)
      rebuildSelectionsFromCheckboxes();
      const orderLower = urlOrder.map(s => s.toLowerCase());
      const byResolved = new Map(selections.map(s => [s.resolved, s]));
      selections = orderLower.map(raw => {
        const resolved = resolveHandle(raw);
        const existing = byResolved.get(resolved);
        return existing ? { ...existing, raw } : { raw, resolved };
      });
      renderOrderedView();

      selections.forEach(s => hydrateDrawerFromColumn(s.resolved));

      if (models.length) window.LectricCompare?.forceFromModels(models);
    }

    window.addEventListener('popstate', onHistoryChange);
    window.addEventListener('pageshow', onHistoryChange); // BFCache restore
  })();

  // --- Color swatches (image + CTA) ---
  (function () {
    function setCtaFromBubble(card, bubble) {
      if (!card || !bubble) return;
      const btn = card.querySelector('.bottom-col a.button, .bottom-col a.button--primary');
      if (!btn) return;
      const variantUrl = bubble.dataset.variantUrl || bubble.dataset.variantUrlDefault || '';
      if (variantUrl) btn.setAttribute('href', variantUrl);
    }

    document.querySelectorAll('.results-col').forEach(card => {
      const initialBubble =
        card.querySelector('.color-variant-wrapper .bubble.active') ||
        card.querySelector('.color-variant-wrapper .bubble.selected') ||
        card.querySelector('.color-variant-wrapper .bubble');
      if (initialBubble) setCtaFromBubble(card, initialBubble);
    });

    document.querySelectorAll('.color-variant-wrapper .bubble').forEach(bubble => {
      bubble.addEventListener('click', function (e) {
        e.preventDefault();
        const card = this.closest('.results-col');
        if (!card) return;

        const imageUrl = this.dataset.imageUrl;
        const img = card.querySelector('.bike-image img');
        if (img && imageUrl) img.src = imageUrl;

        card.querySelectorAll('.color-variant-wrapper .bubble.active').forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        setCtaFromBubble(card, this);
      });
    });
  })();

  /* --- top-filters-bar collapse/expand --- */
  document.addEventListener('DOMContentLoaded', () => {
    const TOP_BAR = document.querySelector('.top-filters-bar');
    const WRAP = document.querySelector('.compare-main .compare-filters__wrap');
    if (!TOP_BAR || !WRAP) return;

    WRAP.style.display = '';
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    if (isMobile) {
      WRAP.classList.add('is-collapsed');
      TOP_BAR.classList.remove('active');
      TOP_BAR.setAttribute('aria-expanded', 'false');
    } else {
      WRAP.classList.remove('is-collapsed');
      TOP_BAR.classList.add('active');
      TOP_BAR.setAttribute('aria-expanded', 'true');
    }

    TOP_BAR.addEventListener('click', () => {
      const isCollapsed = WRAP.classList.toggle('is-collapsed');
      TOP_BAR.classList.toggle('active', !isCollapsed);
      TOP_BAR.setAttribute('aria-expanded', String(!isCollapsed));
    });
  });

  /* --- height logic --- */
  (function () {
    function runWhenReady() {
      if (document.readyState === 'complete') {
        initContainerHeight();
      } else {
        window.addEventListener('load', initContainerHeight);
        setTimeout(initContainerHeight, 3000);
      }
    }
    runWhenReady();
    window.addEventListener('resize', () => {
      document.querySelectorAll('[style*="min-height"]').forEach(el => el.style.minHeight = '');
      initContainerHeight();
    });
  })();

  /* --- sidebar padding logic --- */
  (function () {
    const itemsFixed = document.querySelector('.compare-results__items-fixed');
    const sidebar = document.querySelector('.compare-results__sidebar .empty-sidebar-div');
    const bodyOverflow = document.querySelector('body');
    bodyOverflow.classList.add('bodyOverflow');
    if (!itemsFixed || !sidebar) return;
    function updateSidebarPadding() {
      const height = itemsFixed.getBoundingClientRect().height;
      sidebar.style.height = `${height}px`;
    }
    window.addEventListener('load', updateSidebarPadding);
    window.addEventListener('resize', updateSidebarPadding);
  })();

  /* --- scroll sync logic --- */
  (function () {
    const panes = Array.from(document.querySelectorAll('.compare-results__items'));
    if (panes.length < 2) return;
    let isSyncing = false;
    panes.forEach(pane => {
      pane.addEventListener('scroll', () => {
        if (isSyncing) return;
        isSyncing = true;
        const x = pane.scrollLeft;
        panes.forEach(other => { if (other !== pane) other.scrollLeft = x; });
        requestAnimationFrame(() => isSyncing = false);
      }, { passive: true });
    });

    let startX, startY, startScroll;
    panes.forEach(pane => {
      pane.addEventListener('touchstart', event => {
        const t = event.touches[0];
        startX = t.pageX; startY = t.pageY; startScroll = pane.scrollLeft;
      }, { passive: true });
      pane.addEventListener('touchmove', event => {
        const t = event.touches[0];
        const dx = t.pageX - startX; const dy = t.pageY - startY;
        if (Math.abs(dx) > Math.abs(dy)) {
          event.preventDefault();
          const newLeft = startScroll - dx;
          panes.forEach(other => other.scrollLeft = newLeft);
        }
      }, { passive: false });
    });
  })();

  /* --- scroll effect logic — Anti-Jitter, Site Header Sync & ResizeObserver --- */
  (function () {
    const headerContainer = document.querySelector('.compare-results__items-fixed');
    const stickyWrapper = document.querySelector('.header-area-sticky-area');
    const emptySidebars = Array.from(document.querySelectorAll('.empty-sidebar-div'));
    const sidebarContainer = document.querySelector('.compare-results__sidebar');
    const mainContainer = document.querySelector('.compare-results');
    const siteHeader = document.querySelector('#shopify-section-header, sticky-header, .site-header, header');
    
    // Elements to manipulate
    const extras = Array.from(document.querySelectorAll('.compare-results__items-fixed .color-variant-wrapper, .compare-results__items-fixed .reviews'));
    const bikeImages = Array.from(document.querySelectorAll('.compare-results__items-fixed .bike-image img'));
    const ctaButtons = Array.from(document.querySelectorAll('.sticky-cta-row'));

    if (!headerContainer || !mainContainer) return;

    let isCollapsed = null; // Start null to force initial state set

    // --- 1. The Magic Fix: ResizeObserver ---
    // Instead of syncing heights during scroll events (which causes jitter), 
    // this native browser API perfectly syncs the sidebar and CTA buttons 
    // ANY time the header changes height.
    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        const newHeight = entry.borderBoxSize ? entry.borderBoxSize[0].blockSize : entry.target.getBoundingClientRect().height;
        
        // Match sidebar empty space to header
        emptySidebars.forEach(div => {
          div.style.height = newHeight + 'px';
          div.style.minHeight = newHeight + 'px';
        });

        // Lock the scrolling "Learn More" buttons directly under the header
        ctaButtons.forEach(btn => {
          btn.style.top = newHeight + 'px';
        });
      }
    });
    // Start observing the header
    resizeObserver.observe(headerContainer);


    // --- 2. Scroll Logic: Offset Tracking & Clean Toggling ---
    function onScroll() {
      // A. Track Site Header (The Logo/Nav bar)
      let offsetTop = 0;
      if (siteHeader) {
        const rect = siteHeader.getBoundingClientRect();
        // If the site header is visible at the top of the screen
        if (rect.bottom > 0 && rect.bottom < 250) {
          offsetTop = rect.bottom;
        }
      }

      // Apply this offset to our sticky elements so they sit strictly below the site header
      if (stickyWrapper) stickyWrapper.style.top = offsetTop + 'px';
      if (sidebarContainer) sidebarContainer.style.top = offsetTop + 'px';
      emptySidebars.forEach(div => { div.style.top = offsetTop + 'px'; });
      
      // Override any negative CSS on the inner container
      headerContainer.style.top = '0px'; 

      // B. Collapse State Logic
      const containerRect = mainContainer.getBoundingClientRect();
      
      // We trigger the collapse exactly when the table hits our site header offset
      // Adding a 5px buffer prevents rapid flickering at the exact boundary
      const shouldCollapse = containerRect.top <= (offsetTop + 5);

      // Only touch the DOM if the state has actually changed
      if (shouldCollapse !== isCollapsed) {
        isCollapsed = shouldCollapse;

        if (isCollapsed) {
          // SCROLLED DOWN: Clean and Lock
          bikeImages.forEach(img => {
            img.style.height = '115px';
            img.style.objectFit = 'contain';
          });
          extras.forEach(el => {
            el.style.display = 'none'; // Hide swatches and reviews instantly
          });
          headerContainer.style.borderBottom = '1px solid #e5e5e5';

        } else {
          // TOP OF PAGE: Expand
          bikeImages.forEach(img => {
            img.style.height = ''; // Clear inline styles, let CSS handle it
          });
          extras.forEach(el => {
            el.style.display = ''; // Show swatches and reviews
          });
          headerContainer.style.borderBottom = 'none';
        }
      }
    }

    // Use requestAnimationFrame for buttery smooth performance
    window.addEventListener('scroll', () => requestAnimationFrame(onScroll), { passive: true });
    window.addEventListener('resize', () => requestAnimationFrame(onScroll));
    
    // Run immediately to set initial offsets
    setTimeout(onScroll, 50);
  })();

  /* --- Drag-to-Scroll (pointer events; dropdown + swatch safe; both panes) --- */
  document.addEventListener('DOMContentLoaded', () => {
    const panes = Array.from(document.querySelectorAll('.compare-results__items'));
    if (!panes.length) return;

    const isInteractive = (el) =>
      el.closest('select, option, button, a, input, label, textarea, .header-dropdown, .color-variant-wrapper, .bubble');

    let dragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let activePane = null;
    let movedEnough = false;
    const DRAG_THRESHOLD = 6;

    const setAllScrollLeft = (x) => panes.forEach(p => { p.scrollLeft = x; });

    panes.forEach(pane => {
      pane.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        if (e.button !== 0) return;
        if (isInteractive(e.target)) return;

        dragging = true;
        movedEnough = false;
        activePane = pane;
        startX = e.clientX;
        startScrollLeft = pane.scrollLeft;

        pane.setPointerCapture(e.pointerId);
        pane.classList.add('active-drag');
      });

      pane.addEventListener('pointermove', (e) => {
        if (!dragging || activePane !== pane) return;
        if (e.pointerType === 'touch') return;

        const dx = e.clientX - startX;

        if (!movedEnough && Math.abs(dx) >= DRAG_THRESHOLD) {
          movedEnough = true;
          e.preventDefault();
        }

        if (!movedEnough) return;

        const walk = dx * 2;
        setAllScrollLeft(startScrollLeft - walk);
      });

      const endDrag = (e) => {
        if (!dragging || activePane !== pane) return;
        try { pane.releasePointerCapture(e.pointerId); } catch (_) {}
        pane.classList.remove('active-drag');

        if (movedEnough) {
          const swallow = (ev) => {
            ev.stopImmediatePropagation();
            ev.preventDefault();
            pane.removeEventListener('click', swallow, true);
          };
          pane.addEventListener('click', swallow, true);
        }

        dragging = false;
        activePane = null;
      };

      pane.addEventListener('wheel', (e) => {
        if (e.ctrlKey || e.metaKey || e.shiftKey) return;

        const prev = pane.scrollLeft;
        const absX = Math.abs(e.deltaX);
        const absY = Math.abs(e.deltaY);

        if (absX >= absY) pane.scrollLeft += e.deltaX;
        else              pane.scrollLeft += e.deltaY;

        const used = pane.scrollLeft !== prev;
        if (used) {
          panes.forEach(p => { if (p !== pane) p.scrollLeft = pane.scrollLeft; });
          e.preventDefault();
        }
      }, { passive: false });

      pane.addEventListener('pointerup', endDrag);
      pane.addEventListener('pointercancel', endDrag);
    });
  });

  /* --- "More Specs" Toggle --- */
  (function () {
    const toggleButton = document.querySelector('.toggle-more-specs');
    const hiddenSpecElements = document.querySelectorAll('.hidden-specs');
    if (!toggleButton || !hiddenSpecElements.length) return;

    const buttonTextSpan = toggleButton.querySelector('span');

    toggleButton.addEventListener('click', () => {
      const isVisible = hiddenSpecElements[0].classList.contains('show');

      toggleButton.classList.toggle('active', !isVisible);
      if (buttonTextSpan) {
        const moreText = toggleButton.dataset.moreText || 'More Specs';
        const lessText = toggleButton.dataset.lessText || 'Less Specs';
        buttonTextSpan.textContent = !isVisible ? lessText : moreText;
      }

      if (isVisible) {
        hiddenSpecElements.forEach(el => el.classList.remove('show'));
        const onTransitionEnd = () => {
          hiddenSpecElements.forEach(el => el.classList.remove('showing'));
          hiddenSpecElements[0].removeEventListener('transitionend', onTransitionEnd);
        };
        hiddenSpecElements[0].addEventListener('transitionend', onTransitionEnd);
      } else {
        hiddenSpecElements.forEach(el => el.classList.add('showing'));
        setTimeout(() => {
          hiddenSpecElements.forEach(el => el.classList.add('show'));
          setTimeout(() => initContainerHeight(true), 450);
        }, 20);
      }
    });
  })();

  /* --- Filter Column Accordion Toggle --- */
  document.addEventListener('DOMContentLoaded', () => {
    const filterColumns = document.querySelectorAll('.compare-filters__column:not(.all-models)');
    filterColumns.forEach(column => {
      const header = column.querySelector('h3');
      if (!header) return;
      column.classList.remove('is-collapsed');
      header.classList.add('active');
      header.addEventListener('click', () => {
        header.classList.toggle('active');
        column.classList.toggle('is-collapsed');
      });
    });
  });

})();
